
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import {
  Preview,
  ComponentDocs,
  Code,
} from "@lighting-beetle/lighter-styleguide";
import Button, { ButtonLayout } from "./../";
import { Grid, GridCol, Icon } from "../../";

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Button`}</h1>
    <h2>{`Example`}</h2>
    <Button mdxType="Button">Button</Button>
    <h2>{`Variants`}</h2>
    <h3>{`Basic`}</h3>
    <p>{`Buttons are created by using class `}<inlineCode parentName="p">{`.btn`}</inlineCode>{` on any element but it is recommended to use `}<inlineCode parentName="p">{`<a>`}</inlineCode>{`, `}<inlineCode parentName="p">{`<button>`}</inlineCode>{` or `}<inlineCode parentName="p">{`<input>`}</inlineCode>{`.`}</p>
    <Preview code={[<Button key="default" mdxType="Button">Default - button</Button>, <Button href="#" key="link" mdxType="Button">
      Default - link
    </Button>, <Button tag="input" submit value="Default - input" key="input" mdxType="Button" />]} mdxType="Preview">
  <ButtonLayout direction={{
        m: "horizontal"
      }} mdxType="ButtonLayout">
    <Button mdxType="Button">Default - button</Button>
    <Button href="#" mdxType="Button">Default - link</Button>
    <Button tag="input" submit value="Default - input" mdxType="Button" />
  </ButtonLayout>
    </Preview>
    <h3>{`Shapes`}</h3>
    <p>{`There are four basic button shapes. Default, radius, rounded and equilateral. You can set shape of button by using class `}<inlineCode parentName="p">{`.btn--[radius/round/equal]`}</inlineCode>{`. Using both `}<inlineCode parentName="p">{`.btn--equal`}</inlineCode>{` and `}<inlineCode parentName="p">{`.btn--round`}</inlineCode>{` on one button creates a circle!`}</p>
    <Preview mdxType="Preview">
  <ButtonLayout direction={{
        m: "horizontal"
      }} mdxType="ButtonLayout">
    <Button mdxType="Button">Default</Button>
    <Button shape="radius" mdxType="Button">Radius</Button>
    <Button shape="round" mdxType="Button">Round</Button>
    <Button equal mdxType="Button">B</Button>
    <Button equal shape="radius" mdxType="Button">
      B
    </Button>
    <Button equal shape="round" mdxType="Button">
      B
    </Button>
  </ButtonLayout>
    </Preview>
    <h3>{`States`}</h3>
    <p>{`There are four button states: normal, hover (shows on mousehover), active (onclick), disabled.`}</p>
    <Preview mdxType="Preview">
  <ButtonLayout direction={{
        m: "horizontal"
      }} mdxType="ButtonLayout">
    <Button mdxType="Button">Normal</Button>
    <Button isActive mdxType="Button">Normal</Button>
    <Button isDisabled mdxType="Button">Normal</Button>
  </ButtonLayout>
    </Preview>
    <h3>{`Sizes`}</h3>
    <p>{`There are three main sizes of buttons: medium (default), large and small. Size is set with additional class like `}<inlineCode parentName="p">{`.btn--[large/small]`}</inlineCode>{`.`}</p>
    <Preview mdxType="Preview">
  <ButtonLayout direction={{
        m: "horizontal"
      }} mdxType="ButtonLayout">
    <Button size="large" mdxType="Button">Large</Button>
    <Button mdxType="Button">Default</Button>
    <Button size="small" mdxType="Button">Small</Button>
  </ButtonLayout>
  <ButtonLayout direction={{
        m: "horizontal"
      }} mdxType="ButtonLayout">
    <Button size="large" shape="round" mdxType="Button">
      Large
    </Button>
    <Button shape="round" mdxType="Button">Default</Button>
    <Button size="small" shape="round" mdxType="Button">
      Small
    </Button>
  </ButtonLayout>
  <ButtonLayout direction={{
        m: "horizontal"
      }} mdxType="ButtonLayout">
    <Button size="large" equal mdxType="Button">
      B
    </Button>
    <Button equal mdxType="Button">B</Button>
    <Button size="small" equal mdxType="Button">
      B
    </Button>
  </ButtonLayout>
  <ButtonLayout direction={{
        m: "horizontal"
      }} mdxType="ButtonLayout">
    <Button size="large" equal shape="round" mdxType="Button">
      B
    </Button>
    <Button equal shape="round" mdxType="Button">
      B
    </Button>
    <Button size="small" equal shape="round" mdxType="Button">
      B
    </Button>
  </ButtonLayout>
    </Preview>
    <h3>{`Types`}</h3>
    <p>{`There are five main buttons color variatons : default, primary, secondary, link and hollow. Color variation on button are set with additional class like `}<inlineCode parentName="p">{`.btn--[primary/link]`}</inlineCode>{`.`}</p>
    <h4>{`Default`}</h4>
    <Preview mdxType="Preview">
  <ButtonLayout direction="horizontal" mdxType="ButtonLayout">
    <Button mdxType="Button">Default</Button>
    <Button isActive mdxType="Button">Default</Button>
    <Button isDisabled mdxType="Button">Default</Button>
  </ButtonLayout>
    </Preview>
    <h4>{`Primary`}</h4>
    <Preview mdxType="Preview">
  <ButtonLayout direction="horizontal" mdxType="ButtonLayout">
    <Button type="primary" mdxType="Button">Primary</Button>
    <Button type="primary" isActive mdxType="Button">
      Primary
    </Button>
    <Button type="primary" isDisabled mdxType="Button">
      Primary
    </Button>
  </ButtonLayout>
    </Preview>
    <h4>{`Secondary`}</h4>
    <Preview mdxType="Preview">
  <ButtonLayout direction="horizontal" mdxType="ButtonLayout">
    <Button type="secondary" mdxType="Button">Secondary</Button>
    <Button type="secondary" isActive mdxType="Button">
      Secondary
    </Button>
    <Button type="secondary" isDisabled mdxType="Button">
      Secondary
    </Button>
  </ButtonLayout>
    </Preview>
    <h4>{`Link`}</h4>
    <Preview mdxType="Preview">
  <ButtonLayout direction="horizontal" mdxType="ButtonLayout">
    <Button type="link" mdxType="Button">Link</Button>
    <Button type="link" isActive mdxType="Button">
      Link
    </Button>
    <Button type="link" isDisabled mdxType="Button">
      Link
    </Button>
  </ButtonLayout>
    </Preview>
    <h4>{`Hollow`}</h4>
    <Preview mdxType="Preview">
  <ButtonLayout direction="horizontal" mdxType="ButtonLayout">
    <Button type="hollow" mdxType="Button">Hollow</Button>
    <Button type="hollow" isActive mdxType="Button">
      Hollow
    </Button>
    <Button type="hollow" isDisabled mdxType="Button">
      Hollow
    </Button>
  </ButtonLayout>
    </Preview>
    <h3>{`Inline icons`}</h3>
    <p>{`Inline icons sit in line with text.`}</p>
    <h4>{`Icon and text`}</h4>
    <Preview mdxType="Preview">
  <ButtonLayout direction={{
        m: "horizontal"
      }} mdxType="ButtonLayout">
    <Button mdxType="Button">
      <Icon name="heart" size="small" className="icon--left" mdxType="Icon" />
      Button
    </Button>
    <Button type="primary" mdxType="Button">
      Button
      <Icon name="heart" size="small" className="icon--right" mdxType="Icon" />
    </Button>
    <Button type="primary" size="small" mdxType="Button">
      <Icon name="heart" size="small" className="icon--left" mdxType="Icon" />
      Button
    </Button>
    <Button size="large" mdxType="Button">
      Button
      <Icon name="heart" size="medium" className="icon--right" mdxType="Icon" />
    </Button>
  </ButtonLayout>
    </Preview>
    <h4>{`Only icons`}</h4>
    <Preview mdxType="Preview">
  <ButtonLayout direction={{
        m: "horizontal"
      }} mdxType="ButtonLayout">
    <Button mdxType="Button">
      <Icon name="heart" size="small" mdxType="Icon" />
    </Button>
    <Button type="primary" mdxType="Button">
      <Icon name="heart" size="medium" mdxType="Icon" />
    </Button>
  </ButtonLayout>
    </Preview>
    <h3>{`Positioned icons`}</h3>
    <p>{`Unlike inline icons, positioned icons sits outside regular text area at the side of the button.`}</p>
    <Preview mdxType="Preview">
  <Grid mdxType="Grid">
    <GridCol size={{
          m: 2,
          l: 6
        }} mdxType="GridCol">
      <ButtonLayout mdxType="ButtonLayout">
        <Button iconPosition="left" mdxType="Button">
          <Icon name="heart" size="medium" mdxType="Icon" />
          Button
        </Button>
        <Button iconPosition="left" size="large" mdxType="Button">
          <Icon name="heart" size="medium" mdxType="Icon" />
          Button
        </Button>
      </ButtonLayout>
    </GridCol>
    <GridCol size={{
          m: 2,
          l: 6
        }} mdxType="GridCol">
      <ButtonLayout mdxType="ButtonLayout">
        <Button type="primary" iconPosition="right" mdxType="Button">
          <Icon name="heart" size="medium" mdxType="Icon" />
          Button
        </Button>
        <Button type="primary" iconPosition="right" size="small" mdxType="Button">
          <Icon name="heart" size="small" mdxType="Icon" />
          Button
        </Button>
      </ButtonLayout>
    </GridCol>
  </Grid>
    </Preview>
    <h2>{`Props`}</h2>
    <ComponentDocs title="<Button />" component={Button} mdxType="ComponentDocs" />
    <h2>{`Accessibility`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`<Button />`}</inlineCode>{` component can render as `}<inlineCode parentName="p">{`<a>`}</inlineCode>{`, `}<inlineCode parentName="p">{`<button>`}</inlineCode>{` or `}<inlineCode parentName="p">{`<input>`}</inlineCode>{`. Take care to always use the appropriate element. The rule of thumb is to use `}<inlineCode parentName="p">{`<a>`}</inlineCode>{` if it takes you somewhere, `}<inlineCode parentName="p">{`<button>`}</inlineCode>{` if it does something and `}<inlineCode parentName="p">{`<button type="submit">`}</inlineCode>{` or `}<inlineCode parentName="p">{`<input type="submit">`}</inlineCode>{` if it's used for submitting a form. Check the articles below for more information.`}</p>
    <h3>{`Don't disable buttons`}</h3>
    <p>{`Especially form submit buttons. A disabled button is not keyboard focusable. Instead of using the `}<inlineCode parentName="p">{`[disabled]`}</inlineCode>{` attribute, it's advised to rather use `}<inlineCode parentName="p">{`[aria-disabled=true]`}</inlineCode>{` - it still remains focusable, and a screenreader can find it and announce it's contents, along with the information that it's disabled.`}</p>
    <p>{`Users should be able to submit incomplete and invalid forms, and should get relevant validation feedback, which explains what went wrong and how to fix it. It's considered a bad practice to let the user figure out thier errors themselves.`}</p>
    <h3>{`Icons`}</h3>
    <p>{`While it's recommended to always show a textual label acompanying an icon, this rule is often broken. When this happens, always make sure there is a textual alternative readable by assistive technology. There are three options:`}</p>
    <ul>
      <li parentName="ul">{`alt attribute on the icon OR`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`[aria-label]`}</inlineCode>{` on the button element OR`}</li>
      <li parentName="ul">{`a visually visually hidden but accessible element (e.g. `}<inlineCode parentName="li">{`.sr-only`}</inlineCode>{`)`}</li>
    </ul>
    <h3>{`Additional resources:`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.smashingmagazine.com/2019/02/buttons-interfaces/"
        }}>{`When Is A Button Not A Button?`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://formidable.com/blog/2014/05/08/anchors-buttons-and-accessibility/"
        }}>{`Anchors, Buttons, And Accessibility`}</a></li>
    </ul>
    <h2>{`Aliases`}</h2>
    <pre><code parentName="pre" {...{}}>{`<ButtonPrimary /> === <Button type="primary" />
<ButtonSecondary /> === <Button type="secondary" />
<ButtonLink /> === <Button type="link" />
<ButtonHollow /> === <Button type="hollow" />
`}</code></pre>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;